import { DasEndpoint } from '../../../../types/Device';

type DasWBGTEndpoint = DasEndpoint & { isDefaultWbgt: boolean };

export const checkDasWBGTRequiredFields = (
  localName: string,
  localAltitude: string,
  localLongLat: string,
): boolean => {
  return !localName || !localAltitude || !localLongLat;
};

export const checkFormDasWBGT = ({
  endpoint,
  localName,
  localAltitude,
  pinLocation,
  isDefaultWbgt,
}: {
  endpoint: DasWBGTEndpoint;
  localName: string;
  localAltitude: number;
  pinLocation: [number, number];
  isDefaultWbgt: boolean;
}): boolean => {
  if (!localName || !localAltitude) {
    return true;
  }

  if (endpoint.name !== localName) return false;

  if (endpoint.coordinates === null) {
    if (localAltitude || pinLocation[0] || pinLocation[1]) return false;
  } else {
    if (endpoint.coordinates.alt === null) {
      if (localAltitude) return false;
    } else {
      if (endpoint.coordinates.alt !== localAltitude) return false;
    }
    if (endpoint.coordinates.lat !== pinLocation[1]) return false;
    if (endpoint.coordinates.lon !== pinLocation[0]) return false;
  }

  if (endpoint.isDefaultWbgt !== isDefaultWbgt) return false;

  return true;
};
